import { useGetAuthInspectQuery, useGetProfilesQuery } from '../store/backendApi';
import { checkAuthCookies } from '../utils/auth';

/**
 * Shared hook for authentication state and user profile data.
 * Provides consistent access to auth inspection and profile information
 * across the application.
 *
 * The hook checks for auth cookies (session or remember-me) to determine
 * if profile should be fetched. This triggers the refresh token exchange
 * on app load if needed, preventing the Shell from showing "Register" button
 * when a refresh token exists.
 *
 * @returns Authentication state, profile data, and loading state
 */
export function useAuthenticatedUser() {
  const { data: inspectData } = useGetAuthInspectQuery();

  // Check if auth cookies exist (session or remember-me)
  // Only fetch profile if cookies indicate authentication credentials exist
  const hasAuthCookies = checkAuthCookies();

  const { data: profile, isLoading } = useGetProfilesQuery(undefined, {
    skip: !hasAuthCookies, // Skip if no auth cookies at all
  });

  return {
    isProbablyLoggedIn: hasAuthCookies,
    inspectData,
    profile,
    isAuthenticated: !!profile,
    isLoggedIn: !!profile?.userId,
    isLoading, // Shell needs this to show loading state
  };
}
